export class ModerationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async listModerators() {
        return this.client.get('/api/moderation/moderators');
    }
    async listReports(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.limit)
            qs.set('limit', String(params.limit));
        if (params?.status)
            qs.set('status', params.status);
        if (params?.assigned)
            qs.set('assigned', params.assigned);
        if (params?.type)
            qs.set('type', params.type);
        if (params?.category)
            qs.set('category', params.category);
        if (params?.targetIdentityId)
            qs.set('targetIdentityId', params.targetIdentityId);
        if (params?.reporterIdentityId)
            qs.set('reporterIdentityId', params.reporterIdentityId);
        const query = qs.toString();
        return this.client.get(`/api/moderation/reports${query ? `?${query}` : ''}`);
    }
    async getReport(id) {
        return this.client.get(`/api/moderation/reports/${encodeURIComponent(id)}`);
    }
    async getReportScanEvidence(id) {
        return this.client.get(`/api/moderation/reports/${encodeURIComponent(id)}/scan-evidence`);
    }
    async assignReport(id, identityId) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/assign`, { identityId });
    }
    async unassignReport(id) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/unassign`, {});
    }
    async escalateReport(id) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/escalate`, {});
    }
    async changeCategory(id, category) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/category`, { category });
    }
    async addComment(id, body, visibility) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/comment`, { body, visibility });
    }
    async resolveReport(id, params) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/resolve`, params);
    }
    async closeReport(id, reason) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/close`, { reason });
    }
    async reopenReport(id, reason) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/reopen`, { reason });
    }
    async fileLeReport(id, params) {
        return this.client.post(`/api/moderation/reports/${encodeURIComponent(id)}/le-report`, params);
    }
    async listTickets(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.limit)
            qs.set('limit', String(params.limit));
        if (params?.status)
            qs.set('status', params.status);
        if (params?.assigned)
            qs.set('assigned', params.assigned);
        if (params?.category)
            qs.set('category', params.category);
        const query = qs.toString();
        return this.client.get(`/api/moderation/tickets${query ? `?${query}` : ''}`);
    }
    async getTicket(id) {
        return this.client.get(`/api/moderation/tickets/${encodeURIComponent(id)}`);
    }
    async assignTicket(id, identityId) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/assign`, { identityId });
    }
    async unassignTicket(id) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/unassign`, {});
    }
    async escalateTicket(id) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/escalate`, {});
    }
    async addTicketComment(id, params) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/comment`, params);
    }
    async resolveTicket(id, params) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/resolve`, params);
    }
    async closeTicket(id, params) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/close`, params);
    }
    async reopenTicket(id, params) {
        return this.client.post(`/api/moderation/tickets/${encodeURIComponent(id)}/reopen`, params ?? {});
    }
    async listSupportStaff() {
        return this.client.get('/api/moderation/support-staff');
    }
}
//# sourceMappingURL=moderation-api.js.map